import React, { useState, useEffect } from 'react';
import { AppBar, makeStyles, Menu, MenuItem, Button, } from '@material-ui/core';
import { Person } from '@material-ui/icons';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import { toast } from 'react-toastify';
import WorkstationNotificationsDrawer from '../Workstation/WorkstationNotificationsDrawer';
import SelectedWorkstation from '../Workstation/SelectedWorkstation';
import { productionOrderStates as state } from '../../Config/productionOrderStates';
import { dataService } from '../../Services/data.service';
import { useHistory, useLocation } from 'react-router-dom';
import { machineScissorZone, UpperScissorLine11, UpperScissorLine12, LowerScissorLine11, LowerScissorLine12, Line11, Line12 } from '../../Config/constants';
import { HubConnectionBuilder } from '@microsoft/signalr';
import appSettings from '../../appsettings.json';
import { connect } from 'react-redux';
import BreakDownDetectedDialog from './Dialogs/BreakDownDetectedDialog';
import { scissorTypes, scissorStates } from '../../Config/scissorStates';

export const HeaderBar = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [zones, setZones] = useState([])
  const [notificationDrawerOpen, setNotificationDrawerOpen] = useState(false);
  const [notifications, setNotifications] = useState([])
  const [notificationsConnection, setNotificationsConnection] = useState(null);

  const classes = useStyles();
  const { t } = useTranslation();

  let history = useHistory();
  let historyLocation = useLocation();

  useEffect(() => {    
      const newNotificationsConnection = new HubConnectionBuilder()
      .withUrl(appSettings.DEMO_EXTRUSION_INTERFACE_NOTIFICATIONS_HUB_URL)
      .withAutomaticReconnect()
      .build();
    setNotificationsConnection(newNotificationsConnection);
  }, []);

  useEffect(() => {
    if (notificationsConnection) {
      notificationsConnection.start()
        .then(_ => {
          console.log('Notifications connected!');

          notificationsConnection.on('ReceiveMessage', notificationsData => {
            console.log("From notifications hub: ")
            console.log(notificationsData);
            props.actions.setCounter();
          });
        })
        .catch(e => console.log('Notifications connection failed: ', e));
    }

  }, [notificationsConnection]);

  useEffect(() => {

    dataService.getLatestNotifications().then(logs => {

      // console.log(logs)
      logs = filterNotificationsForActiveWorkstations(logs)
      // console.log(logs)
      // var i;
      // for (i = 0; i < logs.length; i++) {
      //   console.log(JSON.parse(logs[i].metaData).find(z => z.MetaDataType === 1).MetaData[0].MachineId)
      // }
      if (JSON.stringify(logs) !== JSON.stringify(notifications)) {
        setNotifications(logs);
      }
    }
    ).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })


    dataService.getMachinesByMachineType(machineScissorZone).then(scissorZones => {
      if (JSON.stringify(zones) !== JSON.stringify(scissorZones)) {
        setZones(scissorZones)
      }

    }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

  }, [props.workstation.activeWorkstations, props.notification.counter]);

  const logout = () => {
    props.actions.setUserToken("");
    props.actions.setUserInfo("");
    history.push('/login');
  }

  const navigateSettings = () => {
    history.push('/settings');
  }

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openNotificationsDrawer = (open) => {
    if (!open) {
      props.actions.resetCounter();
    }

    setNotificationDrawerOpen(open)
  }

  function machineDataChanged(machineData) {
    let tempMachineScissorStates = props.workstationState.workstationsWithScissorStatusInfo.slice();

    let tempScissorStatusses = []
    props.workstationState.workstationsWithScissorStatusInfo.find(x => x.code === String(machineData.lineNumber)).scissorStatuses.map(x => { tempScissorStatusses.push({ ...x }) })

    if (machineData.plannedStop) {
      tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).name = scissorStates.PLANNEDSTOP
      tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).foregroundColorInHex = "#4654FB"
      tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).backgroundColorInHex = "#4654FB1A"

      tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).name = scissorStates.PLANNEDSTOP
      tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).foregroundColorInHex = "#4654FB"
      tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).backgroundColorInHex = "#4654FB1A"
    }
    else if (machineData.stopped) {
      tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).name = scissorStates.UNPLANNEDSTOP
      tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).foregroundColorInHex = "#D84949"
      tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).backgroundColorInHex = "#D849491A"

      tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).name = scissorStates.UNPLANNEDSTOP
      tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).foregroundColorInHex = "#D84949"
      tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).backgroundColorInHex = "#D849491A"
    }
    else {
      if (machineData.lowerScrap) {
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).name = scissorStates.SCRAP
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).foregroundColorInHex = "#F59127"
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).backgroundColorInHex = "#F591271A"
      }
      else {
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).name = scissorStates.PRODUCTION
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).foregroundColorInHex = "#5CC958"
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.LOWER).backgroundColorInHex = "#5CC9581A"
      }
      if (machineData.upperScrap) {
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).name = scissorStates.SCRAP
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).foregroundColorInHex = "#F59127"
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).backgroundColorInHex = "#F591271A"
      }
      else {
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).name = scissorStates.PRODUCTION
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).foregroundColorInHex = "#5CC958"
        tempScissorStatusses.find(x => x.scissorName === scissorTypes.UPPER).backgroundColorInHex = "#5CC9581A"
      }
    }

    // console.log(tempScissorStatusses)
    // console.log(tempMachineScissorStates.find(x => x.code === String(machineData.lineNumber)).scissorStatuses)

    if (JSON.stringify(props.workstationState.workstationsWithScissorStatusInfo.find(x => x.code === String(machineData.lineNumber)).scissorStatuses) !== JSON.stringify(tempScissorStatusses)) {
      tempMachineScissorStates.find(x => x.code === String(machineData.lineNumber)).scissorStatuses = tempScissorStatusses
      props.actions.setWorkstationWithScissorStatusInfo(tempMachineScissorStates)
    }
  }

  const selectLine = (line, orderId) => {

    let qualityCheckPageSwitch = historyLocation.pathname.includes("/qualitychecks/")

    if (!qualityCheckPageSwitch) {
      props.actions.setSelectedWorkstation(line)
    }

    dataService.getProductionOrdersByMachine(line).then(orders => {

      if (historyLocation.pathname.includes("/order/") || historyLocation.pathname.includes("/qualitychecks/")) {

        let firstOrder = orders.find(x => x.productionOrderStatus === state.RUNNING)
        if (!firstOrder) {
          firstOrder = orders.find(x => x.productionOrderStatus === state.PAUSED)
          if (!firstOrder) {
            firstOrder = orders.find(x => x.productionOrderStatus === state.PLANNED)
            if (!firstOrder) {
              firstOrder = orders.find(x => x.productionOrderStatus === state.STOPPED)
              if (!firstOrder) {
                firstOrder = orders.find(x => x.productionOrderStatus === state.DONE)
              }
            }
          }
        }


        orders = orders.filter(o => o.productionOrderStatus === state.PLANNED || o.productionOrderStatus === state.PAUSED || o.productionOrderStatus === state.RUNNING)
        var o;
        var ordersOnZones = false;
        for (o = 0; o < orders.length; o++) {
          if (orders[o].bowMetaData) {
            let metaData = JSON.parse(orders[o].bowMetaData).find(x => x.MetaDataType === 1).MetaData[0]
            if (metaData.UsedZones.length > 0 && !ordersOnZones) {
              ordersOnZones = true
              props.actions.setSelectedZone(zones.find(x => x.id === metaData.UsedZones[0].ZoneId).name)
            }
          }
        }

        if (!ordersOnZones && !qualityCheckPageSwitch) {
          props.actions.setSelectedZone(null)
        }
        if (firstOrder) {
          if (historyLocation.pathname.includes("/order/")) {
            history.push('/order/' + firstOrder.id);
          }
          else {
            dataService.getProductionOrderLineBOMOutProducedByBOMOutId(firstOrder.bomOut[0].id).then(bomOutProduced => {
              props.actions.setSelectedWorkstation(line)
              let progress = Math.ceil(bomOutProduced.quantityProduced / firstOrder.bomOut[0].quantityOnCarrier)
              history.push('/qualitychecks/' + progress + '/' + firstOrder.id);
            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

          }
        }

        if (orderId) {
          history.push('/order/' + orderId);
        }
      }

    }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
  }

  const filterNotificationsForActiveWorkstations = (logs) => {

    let filteredLogs = []
    if (props.workstation.activeWorkstations.some(x => x.id === Line11)) {

      filteredLogs = filteredLogs.concat(logs.filter(x => JSON.parse(x.metaData).find(z => z.MetaDataType === 1).MetaData[0].MachineId === Line11))
      filteredLogs = filteredLogs.concat(logs.filter(x => JSON.parse(x.metaData).find(z => z.MetaDataType === 1).MetaData[0].MachineId === UpperScissorLine11))
      filteredLogs = filteredLogs.concat(logs.filter(x => JSON.parse(x.metaData).find(z => z.MetaDataType === 1).MetaData[0].MachineId === LowerScissorLine11))
    }
    if (props.workstation.activeWorkstations.some(x => x.id === Line12)) {
      filteredLogs = filteredLogs.concat(logs.filter(x => JSON.parse(x.metaData).find(z => z.MetaDataType === 1).MetaData[0].MachineId === Line12))
      filteredLogs = filteredLogs.concat(logs.filter(x => JSON.parse(x.metaData).find(z => z.MetaDataType === 1).MetaData[0].MachineId === UpperScissorLine12))
      filteredLogs = filteredLogs.concat(logs.filter(x => JSON.parse(x.metaData).find(z => z.MetaDataType === 1).MetaData[0].MachineId === LowerScissorLine12))
    }

    filteredLogs = filteredLogs.sort((a, b) => new Date(b.insertedOn) - new Date(a.insertedOn))
    return filteredLogs
  }



  var now = new Date();
  var day = now.getDate();
  var month = now.getMonth() + 1;
  var year = now.getFullYear();
  var hour = now.getHours();
  var minutes = now.getMinutes();
  var seconds = now.getSeconds();
  var zeroHours = ""
  var zeroMinutes = ""
  var zeroSeconds = ""
  var zeroDays = ""
  var zeroMonths = ""

  if (day < 10) {
    zeroDays = "0"
  }
  if (month < 10) {
    zeroMonths = "0"
  }
  if (hour < 10) {
    zeroHours = "0"
  }
  if (minutes < 10) {
    zeroMinutes = "0"
  }
  if (seconds < 10) {
    zeroSeconds = "0"
  }

  var date = zeroDays + day + "/" + zeroMonths + month + "/" + year + " " + zeroHours + hour + ":" + zeroMinutes + minutes + ":" + zeroSeconds + seconds;

  return <React.Fragment>
    <AppBar className={classes.appBar} position="fixed">
      <div className={classes.titleContainer}>
        <div className={classes.smartProduction}>
          <div className={classes.smart}>
            SMART
          </div>
          <div className={classes.production}>
            {props.nav.smart}
          </div>
        </div>
        <div className={classes.date}>
          {date}
        </div>
      </div>    
      {props.nav.showActiveLines ? <div className={classes.lines}>
        <div className={classes.lineText}>{props.workstation.activeWorkstations.length > 0 ? t("LINE") : ""}</div>
        {props.workstation.activeWorkstations.map((x, index) => { return (x.id === props.workstation.selectedWorkstation ? <SelectedWorkstation zones={zones} line={x.code} id={x.id} key={x.id} {...props} actions={props.actions}></SelectedWorkstation> : <button onClick={() => selectLine(x.id)} className={classes.line} key={x.id}>{x.code}</button>) })}
      </div> : <React.Fragment></React.Fragment>}
      <button className={classes.notifications} onClick={() => setNotificationDrawerOpen(true)}>
        <img className={classes.notificationsIcon} alt="notifications" src={process.env.PUBLIC_URL + '/img/notifications.svg'}></img>
        {props.notification.counter > 0 ? <div className={classes.unread}>{props.notification.counter > 99 ? "+99" : props.notification.counter}</div> : <React.Fragment></React.Fragment>}
      </button>
      <div className={classes.userInfoContainer}>
        <Button aria-controls="simple-menu" aria-haspopup="true" className={classes.languageButton} onClick={handleClick}>
          <Person className={classes.person} /> <div className={classes.userInfo}>{props.user.userInfo ? props.user.userInfo.given_name : ""}</div><div className={classes.expandArrow}>
            <ExpandMoreIcon className={classes.arrowIcon}></ExpandMoreIcon>
          </div>
        </Button>
        <Menu id="simple-menu" style={{ marginTop: "20px", marginLeft: "20px" }} anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
          {/* <MenuItem onClick={navigateSettings}>{t('Profile')}</MenuItem> */}
          {/* <MenuItem onClick={navigateSettings}>{t('UserManagement')}</MenuItem> */}
          <MenuItem onClick={logout}>{t('Logout')}</MenuItem>
        </Menu>
      </div>
    </AppBar>
    <BreakDownDetectedDialog {...props} machineDataChanged={machineDataChanged} actions={props.actions} workstation={props.workstation}></BreakDownDetectedDialog>
    <WorkstationNotificationsDrawer notifications={notifications} closeDrawer={() => openNotificationsDrawer(false)} openDrawer={openNotificationsDrawer} drawerOpen={notificationDrawerOpen} {...props} actions={props.actions}></WorkstationNotificationsDrawer>
  </React.Fragment>
}

const useStyles = makeStyles({

  titleContainer: {
    float: 'left',
    width: "250px",
    display: 'inline-block',
    height: "45px",
    marginLeft: "70px"
  },
  person: {
    color: "#020100",
    marginTop: "3px",
    marginRight: "5px"
  },
  userInfo: {
    fontSize: "12px",
    fontFamily: "Lato, sans-serif",
    color: "#000000",
    marginTop: "3px",
  },
  userInfoContainer: {
    float: 'right',
    display: 'inline-block',
    width: "auto",
    height: "45px"
  },
  menuButton: {
    marginRight: '10px'
  },
  appBar: {
    backgroundColor: '#EFEFEF',
    boxShadow: "none",
    borderBottom: "1px solid #DEDEDE",
    height: "45px",
    display: 'inline-block',
    textAlign: "center"
  },
  smart: {
    display: 'block',
    fontSize: "14px",
    fontFamily: "Campton-bold",
    color: "#4654FF",
    height: "12px",
    marginTop: "5px",
    textAlign: "left"
  },
  production: {
    display: 'block',
    fontSize: "14px",
    fontFamily: "Campton-bold",
    color: "#000000",
    height: "12px"
  },
  arrowIcon: {
    fill: FlagstoneTheme.palette.primary.main,
    width: "20px",
    height: "20px"
  },
  expandArrow: {
    marginTop: "2px",
    marginLeft: "5px"
  },
  date: {
    fontSize: "11px",
    fontFamily: "Lato, sans-serif",
    color: "#8D8D8D",
    float: "left",
    marginTop: "15px",
    marginLeft: "10px"

  },
  smartProduction: {
    float: "left"
  },
  lines: {
    display: "inline",
    marginRight: "100px",
    position: "relative",
    top: "7px"
  },
  lineText: {
    fontSize: "14px",
    fontFamily: "Lato, sans-serif",
    color: "#020100",
    display: "inline",
    marginRight: "10px"
  },
  line: {
    fontSize: "14px",
    fontFamily: "Lato, sans-serif",
    color: "#020100",
    display: "inline",
    outline: "none",
    cursor: "pointer",
    border: "none"
  },
  selectedLine: {
    fontSize: "14px",
    fontFamily: "Lato, sans-serif",
    fontWeight: "bold",
    color: "#4654FB",
    backgroundColor: "#E6E8FE",
    display: "inline",
    outline: "none",
    border: "1px solid white",
    borderRadius: "50%",
    width: "30px",
    height: "30px",

  },
  unread: {
    width: "17px",
    height: "17px",
    borderRadius: "50%",
    backgroundColor: "#D84949",
    position: "relative",
    left: "11px",
    bottom: "7px",
    color: "white",
    fontSize: "10px",
    fontFamily: "Lato, sans-serif",
    fontWeight: "bold",
    paddingTop: "2px",
    boxSizing: "border-box"
  },
  notifications: {
    float: "right",
    border: "none",
    outline: "none",
    cursor: "pointer",
    backgroundColor: "rgb(1,1,1,0)"
  },
  notificationsIcon: {
    height: "23px",
    width: "23px",
    marginTop: "11px",
    marginRight: "20px"
  }
});

function mapStateToProps(state) {
  return {
    notification: state.notification,
    workstationState: state.workstationState
  }
}

export default connect(mapStateToProps)(HeaderBar)
